import { Construction } from "lucide-react";

export default function Placeholder({ title, phase = "Fase 1" }) {
    return (
        <div className="p-8 lg:p-10 max-w-3xl">
            <div className="text-[11px] uppercase tracking-[0.3em] text-[color:var(--brand-dark-gold)] font-semibold mb-2">
                Próximamente · {phase}
            </div>
            <h1 className="font-display text-4xl tracking-tight">{title}</h1>
            <div className="mt-8 rounded-md border border-dashed border-border p-10 flex flex-col items-center text-center">
                <Construction className="h-8 w-8 text-muted-foreground" />
                <p className="mt-3 text-sm text-muted-foreground max-w-md">
                    Este módulo se habilitará en {phase}. La navegación, permisos y
                    esquemas de datos ya están reservados en Fase 0.
                </p>
            </div>
        </div>
    );
}
